var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loggedIn)?_c('Layout',[_c('RouterView')],1):_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }